module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/WARRIOR_OF_THE_NORTH_STYLE.ee15967b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/WARRIOR_OF_THE_NORTH_STYLE.png
// module id = 1179
// module chunks = 16